import axiosInstance from '../../../config/axiosInstance';
import type { ConsumptionObservationsResponse } from '../types/consumptionObservations';

const BASE = '/pricing/margin-center';

export async function getConsumptionObservations(params: {
  horizon_days?: number;
  limit?: number;
  cursor?: string;
} = {}): Promise<ConsumptionObservationsResponse> {
  const { data } = await axiosInstance.get<ConsumptionObservationsResponse>(
    `${BASE}/attention/consumption/observations`,
    { params },
  );
  return data;
}
